// Shared entry for static marketing pages (type-*, for-*). Boots the site
// helpers (mobile nav, footer year, FAQ accordion) and runs loadConfig so
// brand title + i18n apply.
import './site';
import { loadConfig } from '../envConfig';

void loadConfig();
